import React from 'react';
import PropTypes from 'prop-types'
import { Col } from '@vds/grids';
import { TextLink } from '@vds/buttons';
import { Body } from '../../common/Typography/index';
import CheckBox from '../../common/CheckBox/index';
import { isMobile } from '../../common/Helpers';



const ConsentMessage = (props) => (

          <div className={isMobile() ? 'tosMobile' : ''} style={{marginTop: "10px", marginLeft:"-5px"}}>
          <Col xs={12} className=" marginTop32 ">
              <CheckBox
                name={!props?.enableNonVZckbox ? 'agreed to receive service and support text messages' : 'sms consent unchecked'}
                className="checkbox"
                id="offersFlag1"
                component="input"
                type="checkbox"
                analyticstrack="5G-sendSpecialOffersCheck"
                data-track={'{"type" : "input", "name" : "contactInfoPage", "state" :"$checkedState"}'.replace(
                  '$checkedState',
                  props.enableCheckbox ? 'checked' : 'Unchecked',
                )}
                selected={props?.enableNonVZckbox}
                onChange={props?.handleNonVzCheckbox}
                arialabel={props?.contact_info_contact_send_offer}
                onKeyPress={props?.handleNonVzCheckbox}
              >
                {props?.contact_info_contact_nonVz_send_offer}
              </CheckBox>
            </Col>
     
          
         
          <Col  xs={12} className="noPadding marginTop30">
           <div className="marginTop32">
           <Body primitive="p" size="large">
             View{' '}
             <TextLink
               target="blank"
               href="https://www.verizon.com/support/noncustomer-texts-legal"
             >
               Terms & Conditions,
             </TextLink>{' '}
             <TextLink
               target="blank"
               href="https://www.verizon.com/about/privacy/"
             >
              Verizon Privacy Policy
             </TextLink>
             {' '}and{' '}
             <TextLink
               target="blank"
               href="https://www.verizon.com/californiaprivacy"
             >
              California Privacy Notice.
             </TextLink>
             </Body>
             </div>
         </Col>
         </div>

  )
ConsentMessage.propTypes = {
    enableNonVZckbox: PropTypes.bool,
    enableCheckbox: PropTypes.bool,
    handleNonVzCheckbox: PropTypes.func,
    contact_info_contact_send_offer: PropTypes.string,
    contact_info_contact_nonVz_send_offer: PropTypes.string,
}

export default ConsentMessage

